import { GenericStyleModel } from '../../Styles/models/generic-style.model';
import { StyleStateEnum } from '../enums/style-state.enum';
import { PaddingModel } from './padding.model';

export class DividerStyleModel extends GenericStyleModel {
    declare styleState: number | string;
    declare displayStyleState: number | string;
    height: number;
    dividerColor: string;
    backgroundColor: string;
    padding: PaddingModel;

    constructor(apiModel?: any) {
        super(apiModel);
        if (apiModel) {
            this.setFromApiModel(apiModel);
        }

        if (!this.height) {
            this.height = 2;
        }

        if (!this.dividerColor) {
            this.dividerColor = '#C7C7C7';
        }

        if (!this.styleState) {
            this.styleState = StyleStateEnum.DEFAULT;
        }

        if (!this.displayStyleState) {
            this.displayStyleState = this.styleState;
        }

        if (!this.backgroundColor) {
            this.backgroundColor = '#FFFFFF';
        }

        if (!this.padding){
            this.padding = new PaddingModel();
            this.padding.paddingOption = true;
            this.padding.topPadding = 20;
            this.padding.bottomPadding = 20;
        }

    }

    clone(): DividerStyleModel {
        const clone = new DividerStyleModel(
            {
                ...this.getDividerStyles(),
                styleState: this.styleState,
                displayStyleState: this.displayStyleState,
            }
        );
        if (this.template) {
            clone.template = this.template.clone();
        }
        return clone;
    }

    equals(other: DividerStyleModel): boolean {
        if (!other) {
            return false;
        }

        if (!super.equals(other, false)) {
            return false;
        }

        if (this.height !== other.height) {
            return false;
        }

        if (this.dividerColor !== other.dividerColor) {
            return false;
        }

        if (this.backgroundColor !== other.backgroundColor) {
            return false;
        }

        if (!this.padding.equals(other.padding)){
            return false;
        }


        return true;
    }

    setFromApiModel(apiModel: any): void {
        super.setFromApiModel(apiModel);

        if (typeof apiModel === 'string') {
            apiModel = JSON.parse(apiModel);
        }

        if (apiModel.hasOwnProperty('height')) {
            this.height = apiModel.height ;
        }

        if (apiModel.hasOwnProperty('dividerColor')) {
            this.dividerColor = apiModel.dividerColor ;
        }
        if (apiModel.hasOwnProperty('backgroundColor')) {
            this.backgroundColor = apiModel.backgroundColor;
        }
        if (apiModel.hasOwnProperty('padding')) {
            this.padding = new PaddingModel(apiModel.padding.paddingAll, apiModel.padding.paddingOption, apiModel.padding.topPadding,
                apiModel.padding.leftPadding, apiModel.padding.bottomPadding, apiModel.padding.rightPadding);
        }
    }

    /**
     * Keeps a common source of properties for the divider to be used by the Api and block styles
     */
    private getDividerStyles(): any {
        return {
            height: this.height,
            dividerColor: this.dividerColor,
            backgroundColor: this.backgroundColor,
            padding: this.padding
        };
    }

    toBlockStyle(): any {
        if (!this.isSavedStyle()) {
            return {
                ...this.getDividerStyles(),
                styleState: this.styleState,
                displayStyleState: this.displayStyleState,
            };
        } else {
            return {
                styleState: this.styleState
            };
        }
    }

    toApi(): any {
        return {
            ...this.getDividerStyles(),
            defaultReference: this.defaultReference ? this.defaultReference : StyleStateEnum.DEFAULT
        };
    }
}
